import {useContext} from 'react'
import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import {StoreFrontScriptManagerContext} from '../../context'

const DeleteScriptModal = ({script, onClose}: any) => {
  const {deleteScript, isOperationLoading, isLoading} =
    useContext(StoreFrontScriptManagerContext)

  const onDelete = () => {
    deleteScript(script?.id)
  }

  return (
    <ConfirmationModal
      show={true}
      onClose={onClose}
      onAction={onDelete}
      isOperationLoading={isOperationLoading}
      isDataLoading={isLoading}
      body={
        <>
          <p className='mb-2'>
            Do you really want to delete the <strong>{script.name}</strong> script?
          </p>
          <p>This action is irreversible and will remove all associated data.</p>
        </>
      }
      actionName='Delete Mapping'
      actionBtnClass='btn-danger'
    />
  )
}

export default DeleteScriptModal
